export const ROADMAP_ROW_HEIGHT = 56;

/** Markers closer than this (px) collapse into a single count-badged cluster. */
export const MARKER_CLUSTER_THRESHOLD = 14;

export const NEUTRAL_COLOR = "var(--color-grey-400)";

export const LANE_GAP = 4;

export const MAX_ROADMAP_LANES = 4;
